export default __webpack_public_path__ + "729c056d18d13d5b76ccd4470cdb1ef9.svg";